import { useChannelWithFallback } from '@/api/hooks'
import { CollectionLabel, colorsClassName } from '@/app/components/collections/ui'
import LockIcon from '@/app/icons/lock'
import createPlaceholderGif from '@/app/util/gif-skeleton'
import { cn } from '@/util/cn'
import { IChannel } from '@giphy/js-types'
import { Gif } from '@giphy/react-components'
import Link from 'next/link'
const ChannelGridItem = ({
    className,
    channel: _channel,
    width,
    height,
}: {
    channel: IChannel
    width: number
    height: number
    className?: string
}) => {
    const { data: channel = _channel } = useChannelWithFallback(_channel)
    const fg = channel.featured_gif || createPlaceholderGif({ id: `gif-${channel.id}` })
    return (
        <Link href={channel.url} className={cn('relative overflow-hidden rounded-md', colorsClassName, className)}>
            <Gif
                borderRadius={0}
                className={cn('[&_img]:h-full', fg.is_sticker ? '[&_img]:object-contain' : '[&_img]:object-cover')}
                hideAttribution
                gif={fg}
                width={width}
                height={height}
                percentWidth="100%"
                noLink
                overlay={() => {
                    return channel.is_private ? (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <LockIcon className="fill-giphyRed size-4 md:size-7" />
                        </div>
                    ) : null
                }}
            />
            <CollectionLabel label={channel.short_display_name || channel.display_name} />
            {channel.num_children > 0 && (
                <div
                    className={cn(
                        'bg-giphyDarkCharcoal/50 border absolute right-3 top-3 flex cursor-pointer gap-2 rounded-lg p-2.5 text-center text-xs font-bold md:text-sm'
                    )}
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                >
                    {channel.num_children} more
                </div>
            )}
        </Link>
    )
}

export default ChannelGridItem
